import { render, staticRenderFns } from "./ReplenishOrder.vue?vue&type=template&id=98b2bfe2&scoped=true"
import script from "./ReplenishOrder.vue?vue&type=script&lang=js"
export * from "./ReplenishOrder.vue?vue&type=script&lang=js"
import style0 from "./ReplenishOrder.vue?vue&type=style&index=0&id=98b2bfe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b2bfe2",
  null
  
)

export default component.exports